import React from 'react';
import { Alert } from 'reactstrap';
import PropTypes from 'prop-types';

const Directives = (props) => {
  const {
    instructions, handleInputChange, data, isViewOnly,
  } = props;
  const { category } = data;

    return (
      <div>
        {
          !isViewOnly && (
            <Alert color="info">
              Permettez la poursuite de votre activité en cas d'incapacité : qu'il s'agisse d'une to-do list d'urgence ou d'indications plus précises.
            </Alert>
          )
        }
        {
          (isViewOnly && !instructions) ? (
            <div>
              Aucune directive renseignée.
            </div>
          ) : (
            <form className="form bigger-input">
              <div className="form__form-group">
                <div className="form__form-group-field">
                  <textarea
                    placeholder={`Précisez vos directives et assurez la pérénnité de votre ${category === 'company' ? 'entreprise' : 'bien immobilier'} quoi qu'il arrive.`}
                    required
                    style={{ height: 200, minHeight: 200 }}
                    value={instructions || ''}
                    name="instructions"
                    onChange={handleInputChange}
                    maxLength="4000"
                    disabled={isViewOnly}
                  />
                </div>
              </div>
            </form>
          )
        }
      </div>
    );
};

Directives.propTypes = {
  instructions: PropTypes.string,
  handleInputChange: PropTypes.func,
  data: PropTypes.shape({}).isRequired,
  isViewOnly: PropTypes.bool,
};

Directives.defaultProps = {
  instructions: '',
  handleInputChange: () => {},
  isViewOnly: false,
};

export default Directives;
